import React from 'react';
import { Popover } from 'design-system';
import { makeStyles } from 'design-system/compat';

const useStyle = makeStyles(() => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: '19px 16px',
    maxWidth: '309px',
  },
  confirmationPaper: {
    maxWidth: 'unset !important',
  },
  root: {
    '& .MuiPaper-root': {
      background: 'transparent',
    },
    '& .MuiPaper-elevation24': {
      boxShadow: 'none',
    },
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 'unset !important',
    },
  },
}));

const PopoverModal = ({ grave, open, handlePopoverClose, openPhysicalPopover }) => {
  const classes = useStyle();

  return (
    <Popover
      id="mouse-over-popover"
      className={classes.popover}
      classes={{
        paper: classes.paper,
      }}
      open={open}
      anchorEl={openPhysicalPopover}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus
    >
      <div className="mouse-over-popover_physical">
        <span className="mouse-over-popover_physical-header">
          Gravlokasjon forklaring:
          <br />
          <br />
        </span>
        <span className="mouse-over-popover_physical-main">
          <span>{grave?.plot_number}:</span> er gravens lokasjon på gravlunden.
        </span>
        {grave?.plot_number?.split('.')[0] ? (
          <span className="mouse-over-popover_physical-main">
            <span>
              {grave?.plot_number?.split('.')[0] ? grave?.plot_number?.split('.')[0] : ' '}:
            </span>{' '}
            Gravlunden
          </span>
        ) : (
          grave?.plot_number?.split(':')[0] && (
            <span className="mouse-over-popover_physical-main">
              <span>{grave?.plot_number?.split(':')[0]}:</span> Navnet på gravlunden
            </span>
          )
        )}
        {grave?.plot_number?.split('.')[1] ? (
          <span className="mouse-over-popover_physical-main">
            <span>{grave?.plot_number?.split('.')[1]}:</span> Område på gravlunden
          </span>
        ) : (
          grave?.plot_number?.split(':')[1] && (
            <span className="mouse-over-popover_physical-main">
              <span>{grave?.plot_number?.split(':')[1]}:</span> Område på gravlunden
            </span>
          )
        )}
        {grave?.plot_number?.split('.')[2] ? (
          <span className="mouse-over-popover_physical-main">
            <span>{grave?.plot_number?.split('.')[2]}:</span> Rekken der graven befinner seg
          </span>
        ) : (
          grave?.plot_number?.split(':')[2] && (
            <span className="mouse-over-popover_physical-main">
              <span>{grave?.plot_number?.split(':')[2]}:</span> Rekken der graven befinner seg
            </span>
          )
        )}
        {grave?.plot_number?.split('.')[3] ? (
          <span className="mouse-over-popover_physical-main">
            <span>{grave?.plot_number?.split('.')[3]}:</span> Plassering i rekken
          </span>
        ) : (
          grave?.plot_number?.split(':')[3] && (
            <span className="mouse-over-popover_physical-main">
              <span>{grave?.plot_number?.split(':')[3]}:</span> Plassering i rekken
            </span>
          )
        )}
      </div>
    </Popover>
  );
};

export default PopoverModal;
